// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3fjHY","balanceDisclaimer":"posDashboard_balanceDisclaimer__bhWAD"};